import { useEffect, useRef } from 'react';
import {
  createTransport,
  createXResolveProvider,
  PublicTransport,
  Transport,
} from '@spotify-internal/transport';
import { getSilentAuthToken } from '@lib/auth/accessTokenManager/authActions';
import { AccessToken } from '../auth/accessTokenManager/types';

const useTransport = () => {
  const transportRef = useRef<Transport>();

  useEffect(() => {
    transportRef.current = createTransport({
      providers: {
        endpoints: (() => {
          const xresolveProvider = createXResolveProvider();
          return (publicTransport: PublicTransport) =>
            xresolveProvider(publicTransport).then(endpoints => {
              return {
                ...endpoints,
                // default uses sp-client and we only allow generic.wg in our CSP headers
                webgate: 'https://generic.wg.spotify.com/',
                webapi: 'https://api.spotify.com/',
              };
            });
        })(),
        token: () =>
          getSilentAuthToken().then((token: AccessToken) => {
            return token || '';
          }),
      },
    });
  }, []);

  return transportRef.current;
};

export { useTransport };
